import { IS_DEMO_MODE } from '@/utils/demoMode';
import { UserAttendanceComponent } from './UserAttendance.component';
import { UserAttendanceDemoComponent } from './UserAttendance.demo.component';

export const UserAttendancePage = IS_DEMO_MODE
  ? UserAttendanceDemoComponent
  : UserAttendanceComponent;
